export const CellType = {
  EMPTY: 0,
  CLAIMED: 1,
  BORDER: 2,
  TRAIL: 3,
} as const;

export type CellType = (typeof CellType)[keyof typeof CellType];

export interface Point {
  x: number;
  y: number;
}

export interface Player {
  x: number;
  y: number;
  lives: number;
  score: number;
  isDrawing: boolean;
  fastMode: boolean;
  trail: Point[];
  fuseTimer: number;
  invulnTimer: number;
  shieldActive: boolean;
  turboTimer: number;
  pulseCooldown: number;
}

export interface QixEntity {
  x: number;
  y: number;
  vx: number;
  vy: number;
  radius: number;
  points: Point[];
  stunTimer: number;
}

export interface SparkEntity {
  x: number;
  y: number;
  dirX: number;
  dirY: number;
  speed: number;
  moveTimer: number;
}

export type DroneType = 'scout' | 'hunter' | 'pulsar';

export interface DroneEntity {
  id: string;
  type: DroneType;
  x: number;
  y: number;
  vx: number;
  vy: number;
  radius: number;
  angle: number;
  pulsePhase: number;
  stunTimer: number;
}

export type PowerUpType = 'stasis' | 'turbo' | 'shield';

export interface PowerUpEntity {
  id: string;
  type: PowerUpType;
  x: number;
  y: number;
  radius: number;
  timer: number;
}

export interface ShockwaveRing {
  x: number;
  y: number;
  radius: number;
  maxRadius: number;
  color: string;
  alpha: number;
  age: number;
  maxAge: number;
}

export interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  color: string;
  size: number;
  alpha: number;
  life: number;
  maxLife: number;
}

export interface FloatingText {
  text: string;
  x: number;
  y: number;
  color: string;
  alpha: number;
  life: number;
  maxLife: number;
}

export interface GridSlicerInput {
  left: boolean;
  right: boolean;
  up: boolean;
  down: boolean;
  fire: boolean;
  fastCut?: boolean;
  pulsePressed?: boolean;
  restart: boolean;
}

export interface GridSlicerConfig {
  cols?: number;
  rows?: number;
  width?: number;
  height?: number;
  initialLives?: number;
  targetPercentage?: number;
}
